import ContactPage from '../../elements/ContactPage';

export default function BalingWireQuotation() {
  return <ContactPage initialTab="wire" />;
}
